import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import ProjectCards from "./ProjectCards";
import Particle from "../Particle";
import "./Projects.css";

// IMAGES
import Arzanosphere1 from "../../Assets/Projects/Arzanosphere1.png";
import Arzanosphere2 from "../../Assets/Projects/Arzanosphere2.png";
import Arzanosphere3 from "../../Assets/Projects/Arzanosphere3.png";

import AmazonClone from "../../Assets/Projects/AmazonClone.png";
import Amazon2 from "../../Assets/Projects/Amazon2.png";
import Amazon3 from "../../Assets/Projects/Amazon3.png";

import Voting from "../../Assets/Projects/Voting.png";
import Restaurant from "../../Assets/Projects/Restaurant.png";
import Restaurant2 from "../../Assets/Projects/Restaurant2.png";

import Food1 from "../../Assets/Projects/Food1.png";
import Food2 from "../../Assets/Projects/Food2.png";
import Food3 from "../../Assets/Projects/Food3.png";

import bitsOfCode from "../../Assets/Projects/blog.png";
import FoodDonation from "../../Assets/Projects/FoodDonation.png";

import Ola1 from "../../Assets/Projects/Ola1.png";
import Ola2 from "../../Assets/Projects/Ola2.png";
import Ola3 from "../../Assets/Projects/Ola3.png";

import Healthcare from "../../Assets/Projects/Healthcare.png";
import Healthcare2 from "../../Assets/Projects/Healthcare2.png";

import StudentMental from "../../Assets/Projects/StudentMental health.png";
import VirtualMouse from "../../Assets/Projects/virtualMouse.png";

import editor from "../../Assets/Projects/codeEditor.png";
import Color from "../../Assets/Projects/color1.png";

import Voice from "../../Assets/Projects/voicebasedemail.webp";

import DSA from "../../Assets/Projects/DSA.png";

function Projects() {
  // ✅ FIXED SCROLL OFFSET (prevents navbar overlap)
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -100;
      const y =
        element.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <Container fluid className="project-section">
      <Particle />

      {/* ✅ FIXED STICKY NAV */}
      <div className="sticky-nav">
        <Button onClick={() => scrollToSection("fullstack")}>
          Full Stack
        </Button>
        <Button onClick={() => scrollToSection("analytics")}>
          Data Analytics
        </Button>
        <Button onClick={() => scrollToSection("aiml")}>
          AI/ML
        </Button>
        <Button onClick={() => scrollToSection("dsa")}>
          DSA
        </Button>
      </div>

      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works</strong>
        </h1>

        <p style={{ color: "white" }}>
          Here are a few projects, kindly mail me to get SourceCode.
        </p>

        <br />
        {/* 🔥 FEATURED / TRENDING REPO */}
        <div className="featured-repo">
          <div className="featured-content">
            <span className="badge">🔥 Trending Repo</span>

            <h3>Human Eyes Disease Prediction</h3>

            <p>
              My most starred 🌟 GitHub project with full-stack eCommerce features.
            </p>

            <div className="featured-buttons">
              <a
                href="https://github.com/Arzan101/Human-Eye-DiseasesPrediction"
                target="_blank"
                rel="noreferrer"
              >
                View Code
              </a>

              <a
                href="https://human-eye-diseasesprediction-2.streamlit.app/"
                target="_blank"
                rel="noreferrer"
              >
                Live Demo
              </a>
            </div>
          </div>
        </div>


        {/* ================= FULLSTACK ================= */}
        <div id="fullstack" className="section-title">
          <h1>Full Stack WebApp & Mobile App</h1>
        </div>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCards
              imgPaths={[Arzanosphere1, Arzanosphere2, Arzanosphere3]}
              title="ArzanOpsheres"
              description="Daily Astronomy Pictures from NASA APOD API, gallery view, dark mode & fully responsive design."
              ghLink="https://github.com/Arzan101/arzanosphere-main"
              demoLink="https://arzanosphere.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCards
              imgPaths={[Food1, Food2, Food3]}
              title="FoodApp"
              description="FoodMania helps users discover, share & discuss recipes with a strong community experience."
              ghLink="https://github.com/Arzan101/Food"
              demoLink="https://foodmania-production.up.railway.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCards
              imgPaths={[AmazonClone, Amazon2, Amazon3]}
              title="Amazon Clone"
              description="Full-stack eCommerce app with Firebase, Stripe payments, auth & real-time data."
              ghLink="https://github.com/Arzan101/amazon-clone"
              demoLink="https://user-images.githubusercontent.com/84129750/189396401-e79e6851-8e8d-48d0-9f48-fe5f8be44545.mp4"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCards
              imgPaths={[Restaurant, Restaurant2]}
              title="Restaurant-App"
              description="React Native app to explore restaurants, menus, maps & reviews."
              ghLink="https://github.com/Arzan101/Restaurant"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCards
              imgPaths={[FoodDonation, bitsOfCode]}
              title="Food Donation App"
              description="Connects NGOs & volunteers using React + Firebase."
              ghLink="https://github.com/Arzan101/Food-donation-App"
            />
          </Col>
        </Row>

        {/* ================= ANALYTICS ================= */}
        <div id="analytics" className="section-title delay-1">
          <h1>Data Analytics</h1>
        </div>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCards
              imgPaths={[Ola1, Ola2, Ola3]}
              title="Ola Data Analytics (PowerBI)"
              description="Analyzed ride cancellations using SQL & PowerBI dashboards."
              ghLink="https://github.com/Arzan101/Ola-Data-analytics"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCards
              imgPaths={[Healthcare, Healthcare2]}
              title="Healthcare Dashboard (PowerBI)"
              description="Insights into patient data, performance & hospital analytics."
              ghLink="https://github.com/Arzan101/Health-care-Dashboard"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCards
              imgPaths={[StudentMental]}
              title="Student Mental Health (Tableau)"
              description="Visual dashboard analyzing stress, anxiety & trends."
            />
          </Col>
        </Row>

        {/* ================= AI/ML ================= */}
        <div id="aiml" className="section-title delay-1">
          <h1>Artificial Intelligence & Machine Learning</h1>
        </div>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCards
              imgPaths={[Voting]}
              title="Smart Voting System"
              description="Secure voting system using MERN + face recognition."
              ghLink="https://github.com/Arzan101/SmartVotingSystem-main"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCards
              imgPaths={[VirtualMouse]}
              title="Virtual Mouse"
              description="Control mouse using hand gestures via OpenCV & Mediapipe."
              ghLink="https://github.com/Arzan101/Virtual_Mouse"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCards
              imgPaths={[Color]}
              title="ColorAid for Colorblind"
              description="Enhances color visibility using OpenCV processing."
              ghLink="https://github.com/Arzan101/Color-Detection"
            />
          </Col>
        </Row>

        {/* ================= DSA ================= */}
        <div id="dsa" className="section-title delay-1">
          <h1>Data Structures & Algorithms</h1>
        </div>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCards
              imgPaths={[DSA]}
              title="DSA Java"
              description="Topic-wise Java DSA repo covering core concepts & patterns."
              ghLink="https://github.com/Arzan101/DSA-JAVA"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;